import { IconTrash } from "@tabler/icons-react";
import AppContext from "Context/appContext";
import { DISPLAYING_PAGES } from "constants";
import { useContext, useState } from "react";

const IssueList = () => {
  const {
    productCartDetail,
    setProducts,
    products,
    setProductCartDetail,
    currentState,
    userSettings,
    countryDetails,
  } = useContext(AppContext);

  // State is now local to each component instance
  const [isExpanded, setExpandedId] = useState(null);

  const toggleDescription = (id) => {
    setExpandedId((prevId) => {
      // If the clicked ID matches the current expandedId, collapse it
      // Otherwise, expand the clicked ID
      if (prevId === id) {
        return null;  // Collapse the description
      }
      
      return id;  // Expand the description
    });
    
    const service = productCartDetail.services.find(service => service.id === id);
    if (service) {
      // You can modify the service state here based on its expanded/collapsed status
      service['isExpanded'] = service['isExpanded'] ? false : true;  // Toggle visibility
    }
  };
  


  const deleteAndUpdatePrice = (product) => {
    const updatedList = productCartDetail.services.filter((p) => {
      const key = p?.hasOwnProperty("_id") ? "_id" : "id";
      return p[key] !== product[key];
    });
    const price = product?.sale_price?.startsWith("0")
      ? product?.retail_price
      : product?.sale_price;
    let totalPrice =
      productCartDetail?.totalPrice - (product?.price ? product?.price : price);
    if (isNaN(totalPrice) || totalPrice === undefined) {
      totalPrice = 0;
    }
    if (updatedList)
      setProductCartDetail({
        ...productCartDetail,
        totalPrice,
        services: updatedList,
      });
    const findIndex = products.findIndex((p) => {
      const key = p?.hasOwnProperty("_id") ? "_id" : "id";
      return p[key] === product[key];
    });
    if (findIndex !== -1) {
      products[findIndex].active = false;
      // products[findIndex].active = !product.active;
      setProducts(products);
    }
  };

  return productCartDetail?.services.map((s, idx) => (
    <div
      key={s._id || idx}
      className="rd-quote-flex rd-quote-border-b rd-quote-py-2 rd-quote-flex-row rd-quote-justify-between rd-quote-mt-2"
    >
      <div className="rd-quote-flex rd-quote-flex-row rd-quote-justify-start rd-quote-items-center">
        {s.picture && (
          <img className="quote-cart-issue-img" alt="P" src={s.picture} />
        )}
        <div className="rd-quote-gap-y-1">
          <div className="rd-quote-flex rd-quote-flex-col rd-quote-ml-2 rd-quote-text-gray-800 rd-quote-text-sm rd-quote-font-normal">
            {s.name}
          </div>
          {userSettings.showDescription && s.item_description && ( 
            <div className="rd-quote-text-xs rd-quote-text-gray-500 rd-quote-ml-2 rd-quote-pr-1">
              {s.isExpanded ? (
                <>
                  {s.item_description}{" "}
                  <span
                    onClick={() => toggleDescription(s.id)}
                    style={{
                      '--button-bg-color': userSettings?.colourHex?.buttonAndBorderColor || '#ebebeb'
                    }}
                    className="rd-quote-text-[var(--button-bg-color)] rd-quote-cursor-pointer"
                  >
                    Show less
                  </span>
                </>
              ) : (
                <>
                  {s.item_description.slice(0, 60)}{" "}
                  {s.item_description.length > 60 && (
                    <span
                      onClick={() => toggleDescription(s.id)}
                      style={{
                        '--button-bg-color': userSettings?.colourHex?.buttonAndBorderColor || '#ebebeb'
                      }}
                      className="rd-quote-text-[var(--button-bg-color)] rd-quote-cursor-pointer"
                    >
                      Show more
                    </span>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="rd-quote-flex rd-quote-flex-row rd-quote-justify-between">
        {userSettings?.isPricesEnabled && (
          <div className={`rd-quote-bg-sky-100 rd-quote-h-fit rd-quote-rounded ${!s.price ? 'rd-quote-hidden' : ''}`}>
            <div className="rd-quote-text-center rd-quote-text-sky-700 rd-quote-text-xs rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-p-1 rd-quote-leading-none">
              {s.price ? `${countryDetails?.currency_symbol || "$"}` + s.price?.toFixed(2) : ""}
            </div>
          </div>
        )}

        <span
          onClick={() => deleteAndUpdatePrice(s)}
          className="rd-quote-ml-2 rd-quote-text-gray-500 hover:rd-quote-text-red-600 rd-quote-cursor-pointer"
        >
          {currentState === DISPLAYING_PAGES.PRODUCT && (
            <IconTrash className="rd-quote-w-5 rd-quote-h-5" />
          )}
        </span>
      </div>
    </div>
  ));
};

export default IssueList;
